import { Box } from "@mui/material";
import NavBar from "./Navbar";
import TopBar from "./TopBar";
import { useDashboardLayoutData } from "./DashboardLayoutData";
import { URL_CONFIG } from "../../config/urlConfig";
import "./index.scss";

const DashboardLayout = ({ children }) => {
  const {
    themeSeeting,
    isMobileNavOpen,
    setMobileNavOpen,
    isSidebarOpen,
    setSidebarOpen,
  } = useDashboardLayoutData();

  return (
    <Box
      className={`dashboard-layout ${
        themeSeeting.settings.theme === "DARK"
          ? "dashboard-layout--dark"
          : "dashboard-layout--light"
      } ${!isSidebarOpen ? "dashboard-layout--collapsed" : ""}`}
    >
      {URL_CONFIG.SHOW_SIDEBAR && (
        <NavBar
          onMobileClose={() => setMobileNavOpen(false)}
          openMobile={isMobileNavOpen}
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
        />
      )}

      <Box
        className={`dashboard-layout__wrapper ${
          themeSeeting.settings.theme === "DARK"
            ? "dashboard-layout__wrapper--dark"
            : "dashboard-layout__wrapper--light"
        }`}
      >
        <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />

        <Box className="dashboard-layout__content-wrapper">
          <Box className="dashboard-layout__content-container">
            <Box className="dashboard-layout__content" id="main-scroll">
              {children}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
